import React, { createContext, useReducer } from 'react';
import axios from 'axios';
import DropReducer from './DropReducer';

const initialState = {
    druid: "",
    isComplete: false,
    isSuccess: false,
};

// Create context
export const DropContext = createContext(initialState);

// Provider component
export const DropProvider = ({ children }) => {
    const [state, dispatch] = useReducer(DropReducer, initialState);

    const generateDruid = async (description) => {
        const res = await axios.post("/drop/drop/allocate", {description: description});
        if (res.data) {
            dispatch({
                type: "GENERATE_DRUID",
                payload: res.data
            });
        }
    };

    const clearDruid = async () => {
        dispatch({
            type: "CLEAR_DRUID"
        });
    };

    return (
        <DropContext.Provider value={{
            ...state,
            clearDruid,
            generateDruid
        }}>
            {children}
        </DropContext.Provider>
    );
};